<template>
  <div class="content">
    <div class="top" v-if="topShow">
      <el-carousel height="40px" indicator-position="outside" :interval="5000">
        <el-carousel-item
          v-for="(item, index) in timeList"
          :key="index"
          v-if="getRestOfDay(item) < 90"
        >
          <div class="top-text" @click="goActivete">
            <img src="@/assets/img/top_icon_news.png" alt="" />
            <div class="text">
              您的<span style="color: red">{{
                index == 0 ? "基础套餐" : "分销套餐"
              }}</span
              >小程序将于{{ item }}到期，请及时续费，<span>去续费</span>
            </div>
            <img src="@/assets/img/top_icon_arrow_red.png" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--    我的资产-->
    <div class="center-top">
      <div class="center-top-title">我的资产</div>
      <div class="center-top-flex">
        <!-- <div class="center-top-box">
          <img src="@/assets/img/home_icon_pay.png" alt="" />
          <div class="box">
            <div class="box-number">{{ data.userPrice }}</div>
            <div class="box-text">
              销售额(元)
              <el-tooltip class="item" effect="dark" placement="top">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>累计所有用户实际支付过的订单总额（含退款金额）</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div> -->

        <!-- <div class="center-top-box">
          <img src="@/assets/img/home_icon_pay.png" alt="" />
          <div class="box">
            <div class="box-number">{{ data.predictCommission }}</div>
            <div class="box-text">
              预估总佣金(元)
              <el-tooltip class="item" effect="dark" placement="top">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>所有已付款（含退款、关单）订单的实际佣金总和</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div> -->

        <div class="center-top-box">
          <img src="@/assets/img/home_icon_account.png" alt="" />
          <div class="box">
            <div class="box-number">{{ data.waitCommission }}</div>
            <div class="box-text">
              待结算佣金(元)
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>累计所有已出票但未结算的订单佣金总合</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="center-top-box">
          <img src="@/assets/img/home_icon_income.png" alt="" />
          <div class="box">
            <div class="box-number">{{ data.settledCommission }}</div>
            <div class="box-text">
              已结算佣金（元）
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>累计所有已结算的订单佣金总合（含结算后关闭的订单）</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="center-top-box">
          <img src="@/assets/img/home_icon_order.png" alt="" />
          <div class="box">
            <div class="box-number">{{ data.freezeAmount }}</div>
            <div class="box-text">
              冻结金额（元）
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>已申请提现或充值进入账户不可用的金额</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="center-top-box">
          <img src="@/assets/img/home_icon_account.png" alt="" />
          <div class="box">
            <div class="box-number">{{ data.balance }}</div>
            <div class="box-text">
              可用金额（元）
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>当前可提现的金额</p>
                </div>
              </el-tooltip>
            </div>
            <div
              class="box-link"
              @click="turnAccountCenter"
              v-if="isOpenDouyin && isDyAppOwner"
            >
              转至账号中心余额
            </div>
          </div>
        </div>
        <div class="center-top-box">
          <div class="button-cz" @click="goRecharge(1)">充值</div>
          <div class="button-tx" @click="goRecharge(2)">提现</div>
        </div>
      </div>
    </div>
    <!--    数据统计-->
    <div class="center-asset">
      <div class="center-top-title">数据统计</div>
      <div class="center-top-flex">
        <div class="center-top-box">
          <img src="@/assets/img/home_icon_pay.png" alt="" />
          <div class="box">
            <div class="box-number">{{ data.orderAmount }}</div>
            <div class="box-text">
              总销售额（含退款）
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>累计所有已付款订单的支付总额（含退款订单金额）</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="center-top-box">
          <img src="@/assets/img/home_icon_income.png" alt="" />
          <div class="box">
            <div class="box-number">
              {{ data.refundAmount }}
            </div>
            <div class="box-text">
              总退款金额
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>累计所有退款订单的总额</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="center-top-box">
          <img src="@/assets/img/home_icon_account.png" alt="" />
          <div class="box">
            <div class="box-number">
              {{ data.dealAmount }}
            </div>
            <div class="box-text">
              实际成交总金额
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i
                  :style="{ marginLeft: '5px', color: '#909399' }"
                  class="el-icon-question"
                ></i>
                <div slot="content">
                  <p>总销售额 - 总退款金额 + 结算后退款金额</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="center-top-box"></div>
        <div class="center-top-box"></div>
      </div>
    </div>

    <!-- 交易数据 -->
    <div class="center-transaction">
      <div class="center-top-title">
        <div class="title">交易数据</div>
        <div class="times-tab">
          <el-radio-group
            v-model="radioCheck"
            size="mini"
            @change="changeTimeTab"
            fill="#ff8622"
          >
            <!-- <el-radio-button v-for="(item,index) in radioList" :key="index" :label="item.num">{{item.value}}</el-radio-button> -->
            <el-radio-button :label="0">今天</el-radio-button>
            <el-radio-button :label="-1">昨天</el-radio-button>
            <el-radio-button :label="-6">前7天</el-radio-button>
            <el-radio-button :label="-29">前30天</el-radio-button>
            <el-radio-button :label="-59">前60天</el-radio-button>
            <el-radio-button :label="-89">前90天</el-radio-button>
          </el-radio-group>
        </div>
        <div class="timeAll">
          <el-date-picker
            v-model="pickerTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDateTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            :clearable="false"
            :class="radioCheck === ''? 'active-time' :'' "
          >
          </el-date-picker>
        </div>
        <div>
          <el-tooltip class="item" effect="dark" placement="top">
            <i
              :style="{ marginLeft: '5px', color: '#909399' }"
              class="el-icon-question"
            ></i>
            <div slot="content">
              <p>限制近90天，时间为订单创建时间</p>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="transaction-tab">
        <div
          v-for="(item, index) in transactionList"
          :key="index"
          class="transaction-tab-item"
          @click="btnTab(item)"
        >
          <div
            class="transaction-tab-box"
            :class="[statType == item.statType ? 'tab-active' : '']"
          >
            <div
              class="tab-box-num"
              :class="[statType == item.statType ? 'active-font' : '']"
            >
              {{ eCharsdataListAll[item.key] }}
            </div>
            <div class="tab-box-text">
              <div
                class="tab-box-text-s"
                :class="[statType == item.statType ? 'active-font' : '']"
              >
                {{ item.text }}
              </div>
              <el-tooltip effect="dark" placement="bottom" v-if="item.tipShow">
                <i
                  :style="{ marginLeft: '5px' }"
                  class="el-icon-question tips-icons"
                  :class="[statType == item.statType ? 'active-font' : '']"
                ></i>
                <div slot="content">
                  <p>{{ item.tips }}</p>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <el-main
        v-loading="pictLoading"
        element-loading-background="rgba(255, 255, 255, 1)"
        element-loading-text="加载中"
      >
        <div class="echarts-new" id="echartsNow"></div>
      </el-main>
    </div>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import echarts from "echarts";
import { mapGetters } from "vuex";
export default {
  name: "index",
  data() {
    return {
      pickerOptions: {
        // 时间设置选项。限制90天
        disabledDate(time) {
          const curDate = new Date().getTime();
          const minTime = curDate - 90 * 24 * 3600 * 1000; // 90天
          const maxTime = curDate - 1 * 24 * 3600 * 1000; // 昨天
          return time.getTime() > curDate || time.getTime() < minTime;
        },
      },
      pictLoading: false,
      isActive: 1,
      isActiveOrder: 1,
      data: {},
      orderTimeList: [],
      fansTimeList: [],
      orderCountType: 1,
      payAmountType: 1,
      echartsData: {}, // 折线图数据
      echartsDataUser: [],
      echartsDataOrder: [],
      chartLineUser: undefined,
      chartLineOrder: undefined,
      chartNewData: undefined,
      packagePitList: [],
      openAppList: [],
      appKey: "",
      miniDetail: {}, // 当前小程序详情
      timeList: [], //到期时间
      topShow: false,
      profitList: [], // 利润列表
      validPayList: [], //预估佣金折现数据
      // 预估佣金
      predictProfitList: [],
      // 销售额
      validPayAmountList: [],
      eCharsdataList: {
        newUserNum: [], //新增用户=y轴数据
        orderNum: [], //付款订单数（含退款）
        orderPrice: [], //销售额（实际付款金额，含退款）
        refundNum: [], //退款订单数
        refundAmount: [], //退款金额
        dealNum: [], //实际成交订单
        dealAmount: [], //实际成交金额
        predictCommission: [], //成交订单预估佣金
        settledCommission: [], //已结算（成交订单预估佣金的图表需要展示）
        statTime: [], // 日期集合x轴
      },
      eCharsProfitList: [], //利润率(成交订单预估佣金 / 实际成交金额)
      // 总数和，顶部类型
      eCharsdataListAll: {
        newUserNum: "",
        orderNum: "",
        orderPrice: "",
        refundNum: "",
        refundAmount: "",
        dealNum: "",
        dealAmount: "",
        predictCommission: "",
      },
      activeItem: {
        text: "付款订单（含退款）",
        key: "orderNum",
        tips: "所选时间内的所有订单总数（含退款订单）",
        tipShow: true,
        num: "1001",
        statType: 2,
      },
      statType: 2, // 默认类型
      activeStatType: "orderNum", //选中的类型key
      transactionList: [
        {
          text: "新增用户",
          key: "newUserNum",
          tipShow: false,
          num: "100",
          statType: 1,
        },
        {
          text: "付款订单（含退款）",
          key: "orderNum",
          tips: "所选时间内的所有订单总数（含退款订单）",
          tipShow: true,
          num: "1001",
          statType: 2,
        },
        {
          text: "销售额（含退款）",
          key: "orderPrice",
          tips: "所选时间内的所有订单实际支付总额（含退款订单金额）",
          tipShow: true,
          num: "1002",
          statType: 3,
        },
        {
          text: "退款订单",
          key: "refundNum",
          tips: "所选时间（订单创建时间）内的所有退款订单总数，示例：1号订单在4月30日付款，在5月1日退款，则4月30日退款订单+1。",
          tipShow: true,
          num: "1003",
          statType: 4,
        },
        {
          text: "退款金额",
          key: "refundAmount",
          tips: "所选时间（订单创建时间）内的所有退款订单金额总和",
          tipShow: true,
          num: "100",
          statType: 5,
        },
        {
          text: "实际成交订单",
          key: "dealNum",
          tips: "所选时间内的付款订单（含结算后退款订单）-退款订单。示例：4月30日付款的30个订单，4月30-5月2日一共退款3单，则4月30日的实际成交订单为27单。",
          tipShow: true,
          num: "100",
          statType: 6,
        },
        {
          text: "实际成交金额",
          key: "dealAmount",
          tips: "所选时间内付款订单总额（含结算后退款订单）减退款订单总额",
          tipShow: true,
          num: "100",
          statType: 7,
        },
        {
          text: "成交订单预估佣金",
          key: "predictCommission",
          tips: "所选时间内成交订单的实际佣金总和（含结算后退款订单）",
          tipShow: true,
          num: "100",
          statType: 8,
        },
      ],
      chartData: {
        startTime: "",
        endTime: "",
      },
      chartList: {
        xAxisList: [], //x轴
        yAxisList: [], //y轴
      },
      radioList: [
        {
          num: 0,
          value: "今天",
          startTime: "",
          endTime: "",
        },
        {
          num: -1,
          value: "昨天",
        },
        {
          num: -6,
          value: "前7天",
        },
        {
          num: -29,
          value: "前30天",
        },
        {
          num: -59,
          value: "前60天",
        },
        {
          num: -89,
          value: "前90天",
        },
      ],
      nowDay: "",
      radioCheck: -6, //默认前7天
      pickerTime: "", //选择时间
      intervalNum: 0, //x轴间隔
    };
  },
  watch: {
    // chartData: {
    //   handler(newVal, oldVal) {
    //     console.log(newVal, oldVal, "startTime");
    //     // console.log(newVal.endTime === oldVal.endTime)
    //     console.log(newVal.endTime, oldVal.endTime);
    //     console.log(newVal, oldVal, "chartData监听器==");
    //     if (
    //       newVal.startTime === oldVal.startTime &&
    //       newVal.endTime === oldVal.endTime
    //     ) {
    //       console.log("一样==监听器====");
    //     } else {
    //       console.log("不一样，发送请求监听器====");
    //       // this.chartMovieDay();
    //     }
    //   },
    //   deep: true,
    // },
    pickerTime: {
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal, "pickerTime监听器=");
        if (!oldVal) {
          // console.log("BBB");
          return;
        }
        // console.log("CCC");
        this.chartMovieDay();
      },
    },
  },
  created() {
    console.log('minigrp==')
    // this.getBuySeat();
  },
  mounted() {
    this.getNowDay();
    // 初始化
    this.initChartData();
    // this.getBuySeat();
    window.addEventListener("resize", () => {
      // this.chartLineUser.resize();

      // this.chartLineOrder.resize();
      this.chartNewData.resize();
    });
  },
  computed: {
    ...mapGetters(["isOpenDouyin", "isDyAppOwner"]), // 是否是小程序主
  },
  methods: {
    // /选择时间
    changeDateTime(e) {
      let strt = e[0];
      let end = e[1];
      this.chartData = {
        startTime: strt,
        endTime: end,
        // statType: 1,
      };
      let index = this.radioList.findIndex((item) => {
        return item.startTime === strt && item.endTime === end;
      });
      if (index !== -1) {
        this.radioCheck = this.radioList[index].num;
      } else {
        this.radioCheck = "";
      }
      // console.log(index, e, "选择时间changeDateTime");
      // console.log(this.pickerTime, "选择时间pickerTime");
    },
    // 选择时间tab
    changeTimeTab(e) {
      console.log(e, "el-radio");
      let item = this.radioList.find((item) => {
        return item.num === e;
      });
      let arr = [];
      arr[0] = item.startTime;
      arr[1] = item.endTime;
      this.pickerTime = arr;
      // this.radioCheck = e
      // console.log(item, "itemitem");
    },
    setTotal(list) {
      return list.reduce(
        (pre, next) =>
          Math.ceil(Math.round((Number(pre) + Number(next)) * 100)) / 100
      );
    },
    // 点击类型
    btnTab(item) {
      // console.log(item.key, "点击类型的key");
      // console.log(item.statType,'点击类型的statType')
      this.statType = item.statType;
      this.activeStatType = item.key;
      this.activeItem = item;
      this.chartMovieDay();
      console.log(this.statType, "选中类型的statType值");
    },
    chartNew() {
      let that = this;
      // console.log(that.eCharsdataList.statTime, "AAA====");
      // console.log(that.eCharsdataList[that.activeStatType], "BBB====");
      // 用户数
      this.chartNewData = echarts.init(document.getElementById("echartsNow"));
      this.chartNewData.showLoading({
        text: "loading",
        color: "#FF7048",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      });
      var option;
      option = {
        grid:{
          left: '5%'    // 左边距
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: that.eCharsdataList.statTime,
          axisLabel: {
            interval: that.intervalNum, //设置间隔为0
            rotate: 0,
          },
          axisLine: {
            show: false, //隐藏x轴
          },
          axisTick: {
            show: false, //刻度线
          },
        },
        // legend: {
        //   data: ["已结算佣金", "预估佣金"],
        // },
        tooltip: {
          // formatter: function (params) {
          formatter: function (params) {
            // console.log(params, "params===");
            let datas = params[0];
            // 名字
            let name = datas.seriesName;
            // 数量
            let value = datas.value;
            let index = datas.dataIndex;
            var result = "";
            let addText = "";
            if (that.activeStatType == "predictCommission") {
              addText =
                "已结算：" + that.eCharsdataList.settledCommission[index] + "（指当天订单的已结算金额，"+ "<br>" +"&emsp;&emsp;&emsp;&emsp;示例：10日实际成交50单，在看表前放映并结算了49单，就统计49单的佣金）"
              result = params[0].name + "<br>" + name + "：" + value + "（利润率 "+that.eCharsProfitList[index]+"%）"+ "<br>";
              return result + addText;
            } else {
              result = params[0].name + "<br>" + name + "：" + value
              return result;
            }
            // params.forEach((item, index) => {
            //   if (item.seriesName == "已结算佣金") {
            //     result += item.seriesName + ": " + item.value + "<br/>";
            //   } else if (item.seriesName == "预估佣金") {
            //     // 利润率 = 佣金 / 销售额
            //     let profit = "";
            //     if (item.data > 0) {
            //       profit =
            //         Math.round(
            //           (item.data / that.validPayAmountList[item.dataIndex]) *
            //             100 *
            //             100
            //         ) / 100;
            //     } else {
            //       profit = 0;
            //     }
            //     result +=
            //       item.seriesName +
            //       ": " +
            //       item.value +
            //       "(销售额：" +
            //       that.validPayAmountList[item.dataIndex] +
            //       "; 利润率：" +
            //       profit +
            //       "%)";
            //   }
            // });
            // return result;
          },
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "cross", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        yAxis: {
          name: that.activeItem.text, //y轴文字
          type: "value",
          axisLine: {
            show: false, //隐藏y轴
          },
          axisTick: {
            show: false, //刻度线
          },
        },
        series: [
          {
            name: that.activeItem.text,
            data: that.eCharsdataList[that.activeStatType],
            type: "line",
            areaStyle: {
              normal: {
                color: "#fbbf8e", //改变区域颜色
              },
            },
            smooth: true,
            itemStyle: {
              normal: {
                color: "#FF7048", // 改变线条颜色
              },
            },
          },
          // // 第二条折线
          // {
          //   name: "预估佣金",
          //   // data: ["1.00", "1.20", "3.20", "2.50", "2.60", "4.20", "6.20"],
          //   data: this.predictProfitList,
          //   type: "line",
          //   areaStyle: {
          //     normal: {
          //       color: "none", //改变区域颜色
          //     },
          //   },
          //   smooth: true,
          //   itemStyle: {
          //     normal: {
          //       color: "#c280ff", // 改变线条颜色
          //     },
          //   },
          // },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartNewData.setOption(option);
      this.chartNewData.hideLoading();
    },
    // 折线图v3.1.15
    async chartMovieDay() {
      // let data = {
      //   appKey: localStorage.getItem("appKeyMini"),
      //   startTime:'2024-05-21',
      //   endTime:'2024-05-22',
      //   // "统计数据类型(1:新增用户，2:付款订单，3:销售额，4:退款订单，5:退款金额，6:实际成交订单，7:实际成交金额，8:成交订单预估佣金)
      //   statType: 1
      // }
      let params = {};
      params = {
        appKey: localStorage.getItem("appKeyMini"),
        startTime: this.pickerTime[0],
        endTime: this.pickerTime[1],
        // ...this.chartData,
        statType: this.statType,
      };
      try {
        // let loadingInstance = Loading.service({
        //     text: '请稍等',
        //     target: document.querySelector('.echarts-new')
        // })
        this.pictLoading = true;
        const res = await MiniModel.getChartMovieDay(params);
        console.log(res.data.data, "折线图3.1.15");
        if (res.data.code == 200) {
          // 时间间隔
          let intervalDay = this.differenceDay(
            params.startTime,
            params.endTime
          );
          if (intervalDay <= 15) {
            this.intervalNum = 0;
          } else if (intervalDay <= 30) {
            this.intervalNum = 1;
          } else if (intervalDay <= 60) {
            this.intervalNum = 4;
          } else {
            this.intervalNum = 7;
          }
          console.log(intervalDay, "日期时间间隔");
          // 清除
          Object.keys(this.eCharsdataList).forEach((k) => {
            this.eCharsdataList[k] = [];
          });
          let dataList = res.data.data;
          if (dataList.length > 0) {
            let arr = [];
            if (dataList.length > 0) {
              dataList.forEach((obj) => {
                Object.keys(obj).forEach((key) => {
                  if (this.eCharsdataList[key]) {
                    this.eCharsdataList[key].push(obj[key]);
                  }
                  // console.log(key,obj[key]);
                });
              });
              Object.keys(this.eCharsdataList).forEach((itemK) => {
                if (itemK == "statTime" || itemK == "settledCommission") return;
                // console.log(
                //   this.eCharsdataList[itemK],
                //   "this.eCharsdataList[itemK]"
                // );
                // let dealAmountTotal=this.setTotal(this.eCharsdataList[itemK])
                this.eCharsdataListAll[itemK] = this.setTotal(
                  this.eCharsdataList[itemK]
                );
                // console.log(
                //   this.setTotal(this.eCharsdataList[itemK]),
                //   "dealAmountTotal++" + [itemK]
                // );
              });
              // 利润率(成交订单预估佣金 / 实际成交金额)
              this.eCharsProfitList = []
              this.eCharsdataList.predictCommission.forEach((item, index) => {
                // console.log("预估佣金"+item,"实际成交金额"+this.eCharsdataList.dealAmount[index],'利润率利润率')
                let profit = "";
                if (item > 0) {
                  profit =
                    (Math.round(
                      (item / this.eCharsdataList.dealAmount[index]) *
                        100*100
                    ) / 100).toFixed(2);
                } else {
                  profit = 0;
                }
                this.eCharsProfitList.push(profit)
              });
              // console.log(this.eCharsProfitList,'this.eCharsProfitListthis.eCharsProfitList')
              let activeStatType = this.transactionList.find((item) => {
                return item.statType == this.statType;
              });
              this.activeStatType = activeStatType.key;
              // console.log(activeStatType, "activeStatTypeactiveStatType");
            }
            this.chartNew();
            // console.log(
            //   this.eCharsdataList,
            //   "数组集合this.eCharsdataListthis.eCharsdataList=="
            // );
            // console.log(
            //   this.eCharsdataListAll,
            //   "数组总和this.eCharsdataListAll=="
            // );
          }
          this.pictLoading = false;
        }
      } catch (err) {
        this.pictLoading = false;
        console.log(err, "err折线图3.1.15");
      }
    },
    // 初始化
    initChartData() {
      this.chartData.startTime = this.nowDay;
      this.chartData.endTime = this.nowDay;
      this.chartData.statType = 1;
      this.pickerTime = [this.nowDay, this.nowDay];
      this.radioList.forEach((item) => {
        // 获取tab时间
        if (item.value == "昨天") {
          item.startTime = this.getDay(item.num);
          item.endTime = this.getDay(item.num);
        } else {
          item.startTime = this.getDay(item.num);
          item.endTime = this.nowDay;
        }
      });
      let items = this.radioList.find((item) => {
        return item.num === this.radioCheck
      })
      // console.log(items,'itemsitemsitems==')
      // console.log(this.radioList, "this.radioList");
      this.pickerTime = [items.startTime, items.endTime];
      this.getBuySeat()
    },
    // 获取今天
    getNowDay() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      month = month > 9 ? month : "0" + month;
      day = day < 10 ? "0" + day : day;
      var today = year + "-" + month + "-" + day;
      this.nowDay = today;
      console.log(today, "今天");
    },
    // 计算相差天数
    differenceDay(date1, date2) {
      let startTime = new Date(date1);
      let endTime = new Date(date2);
      let usedTime = endTime - startTime; // 相差的毫秒数
      let days = Math.floor(usedTime / (24 * 3600 * 1000)); // 计算出天数
      return days + 1;
    },
    // 获取当前时间前或后的日期（比如前30天，-29）
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },

    // ==========================
    // 转正账号中心
    turnAccountCenter() {
      if (this.data.balance == 0) {
        this.$message({
          type: "error",
          message: "余额为0，无法转移",
        });
        return;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("span", `确认将`),
          h(
            "span",
            { style: "color: red" },
            " " + this.data.balance + "元" + " "
          ),
          h("span", "余额转移至账户中心余额？"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "转移中...";

            const data = await MiniModel.transferAccountCenter({
              appKey: localStorage.getItem("appKeyMini"),
            });
            if (data.data.code === 200) {
              this.$message({
                type: "success",
                message: data.data.message,
              });
              this.getData();
            } else {
              this.$message({
                type: "error",
                message: data.data.message,
              });
            }
            done();
            instance.confirmButtonLoading = false;
          } else {
            done();
            instance.confirmButtonLoading = false;
          }
        },
      });
    },
    // 获取购买席位数量
    getBuySeat() {
      this.pictLoading = true;
      MiniModel.getMiniNum({
        channelType: 0
      }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.packagePitList = res.data.data.packagePitList;
          this.openAppList = res.data.data.openAppList;
          if (localStorage.getItem("appName")) {
            this.appName = localStorage.getItem("appName");
          } else {
            this.appName = this.openAppList[0].appName;
          }
          // 获取当前小程序信息
          if (localStorage.getItem("nowMini")) {
            this.miniDetail = localStorage.getItem("nowMini");
          } else {
            this.miniDetail = this.openAppList[0];
          }
          this.timeList.push(this.miniDetail.packageEffectTime);
          // 如果有分销一起push进去
          if (this.miniDetail.profitPackageEffectTime) {
            this.timeList.push(this.miniDetail.profitPackageEffectTime);
          }
          if (localStorage.getItem("appId") == null) {
            if (this.openAppList && this.openAppList.length) {
              this.appName = this.openAppList[0].appName;
              this.appKey = this.openAppList[0].appKey;
            }
          } else {
            let appId = localStorage.getItem("appId");
            for (let index in this.openAppList) {
              console.log(
                "item.id == appId",
                this.openAppList[index].id == appId
              );
              if (this.openAppList[index].id == appId) {
                console.log("item", this.openAppList[index]);
                this.appName = this.openAppList[index].appName;
                this.appKey = this.openAppList[index].appKey;
                console.log("this.appKey", this.appKey);
                break;
              } else {
                this.appName = this.openAppList[0].appName;
                this.appKey = this.openAppList[0].appKey;
                this.miniActive = 0;
              }
            }
          }
          localStorage.setItem("appKeyMini", this.appKey);
          console.log("this.appKey", this.appKey);
          // if (!localStorage.getItem('appKeyMini')) {
          //
          // }
          if (!localStorage.getItem("pitId")) {
            if (this.packagePitList.length > 0) {
              localStorage.setItem("pitId", this.packagePitList[0].id);
            }
          }
          this.getData();
          // this.getChartData();
          this.chartMovieDay();
        } else {
          this.$message.error(res.info);
          this.pictLoading = false;
        }
      }).catch(()=> {
        this.pictLoading = false;
      })
    },
    // 切换
    selectUser(index) {
      this.isActive = index;
      if (index == 1) {
        this.payAmountType = 1;
      } else {
        this.payAmountType = 2;
      }
      this.getChartData();
    },
    // 切换
    selectOrder(index) {
      this.isActiveOrder = index;
      if (index == 1) {
        this.orderCountType = 1;
      } else {
        this.orderCountType = 2;
      }
      this.getChartData();
    },
    chartUser() {
      let that = this;
      // 用户数
      this.chartLineUser = echarts.init(document.getElementById("echartsUser"));
      var option;
      option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.fansTimeList,
          axisLabel: {
            interval: 0, //设置间隔为0
            rotate: 45,
          },
          axisLine: {
            show: false, //隐藏x轴
          },
          axisTick: {
            show: false, //刻度线
          },
        },
        legend: {
          data: ["已结算佣金", "预估佣金"],
        },
        tooltip: {
          // formatter: function (params) {
          formatter: function (params) {
            // console.log(params, "params===");
            var result = params[0].name + "<br/>";
            params.forEach((item, index) => {
              if (item.seriesName == "已结算佣金") {
                result += item.seriesName + ": " + item.value + "<br/>";
              } else if (item.seriesName == "预估佣金") {
                // 利润率 = 佣金 / 销售额
                let profit = "";
                if (item.data > 0) {
                  profit =
                    Math.round(
                      (item.data / that.validPayAmountList[item.dataIndex]) *
                        100 *
                        100
                    ) / 100;
                } else {
                  profit = 0;
                }
                result +=
                  item.seriesName +
                  ": " +
                  item.value +
                  "(销售额：" +
                  that.validPayAmountList[item.dataIndex] +
                  "; 利润率：" +
                  profit +
                  "%)";
              }
            });
            return result;
          },
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "cross", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false, //隐藏y轴
          },
          axisTick: {
            show: false, //刻度线
          },
        },
        series: [
          {
            name: "已结算佣金",
            data: this.echartsDataUser,
            type: "line",
            areaStyle: {
              normal: {
                color: "none", //改变区域颜色
              },
            },
            smooth: true,
            itemStyle: {
              normal: {
                color: "#FF7048", // 改变线条颜色
              },
            },
          },
          // 第二条折线
          {
            name: "预估佣金",
            // data: ["1.00", "1.20", "3.20", "2.50", "2.60", "4.20", "6.20"],
            data: this.predictProfitList,
            type: "line",
            areaStyle: {
              normal: {
                color: "none", //改变区域颜色
              },
            },
            smooth: true,
            itemStyle: {
              normal: {
                color: "#c280ff", // 改变线条颜色
              },
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartLineUser.setOption(option);
    },
    chartOrder() {
      this.chartLineOrder = echarts.init(
        document.getElementById("echartsOrder")
      );
      var option;
      option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.orderTimeList,
          axisLabel: {
            interval: 0, //设置间隔为0
            rotate: 45,
          },
          axisLine: {
            show: false, //隐藏x轴
          },
          axisTick: {
            show: false, //刻度线
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false, //隐藏x轴
          },
          axisTick: {
            show: false, //刻度线
          },
        },
        tooltip: {
          formatter: function (params) {
            return (
              params[0].name +
              "<br/>" +
              "出票单数" +
              " : " +
              params[0].data +
              "单"
            ); //根据需要拼接
          },
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "cross", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        series: [
          {
            data: this.echartsDataOrder,
            type: "line",
            areaStyle: {
              normal: {
                color: "#409DF7", //改变区域颜色
              },
            },
            smooth: true,
            itemStyle: {
              normal: {
                color: "#409DF7", // 改变线条颜色
              },
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartLineOrder.setOption(option);
    },
    // 充值提现
    goRecharge(index) {
      let recharge;
      if (index === 1) {
        this.$router.push({
          path: "/pc/miniProgram/recharge",
          query: {
            recharge: true,
          },
        });
      } else {
        this.$router.push({
          path: "/pc/miniProgram/recharge",
          query: {
            recharge: false,
          },
        });
      }
    },
    goActivete() {
      this.$router.push("/pc/miniProgram/activate");
    },
    // 获取主页数据
    getData() {
      let param = {
        appKey: this.appKey,
      };
      MiniModel.getHomeData(param).then((res) => {
        if (res.data.code == 200) {
          this.data = res.data.data;
          console.log(res.data.data, "获取主页数据");
        } else {
          this.$message.error(res.data.info);
        }
      });
    },
    getChartData() {
      let param = {
        appKey: localStorage.getItem("appKeyMini"),
        orderCountType: this.orderCountType,
        payAmountType: this.payAmountType,
      };
      MiniModel.getChart(param).then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data.data, "新佣金双折线图getChartData==============");
          this.echartsData = res.data.data;
          let validPayAmountStatVoList = res.data.data.validPayAmountStatVoList;
          let ticketOrderCountStatVoList =
            res.data.data.ticketOrderCountStatVoList;
          let arr = [];
          let arr1 = [];
          let list = [];
          let list2 = [];
          let profitList = [];
          let predictProfitArr = [];
          let validPayAmountArr = [];
          let lirunArr = [];
          // 处理时间
          validPayAmountStatVoList.forEach((item) => {
            arr.push(item.statTime);
            list.push(item.profit);
            profitList.push(item.profit);
            this.fansTimeList = arr;
            this.echartsDataUser = list;
            this.profitList = profitList;
            // 预估佣金
            predictProfitArr.push(item.predictProfit);
            // 销售额
            validPayAmountArr.push(item.validPayAmount);
            // 利润率
            // lirunArr.push(this.returnFloat(item.predictProfit / item.validPayAmount))
            // returnFloat
          });
          this.predictProfitList = predictProfitArr;
          this.validPayAmountList = validPayAmountArr;
          // console.log(this.predictProfitList,this.validPayAmountList,lirunArr,'yuyuyuyuu======')
          // console.log(this.fansTimeList,'this.fansTimeList===日期数组')
          // console.log(this.echartsDataUser,'this.echartsDataUser===新佣金折线数据')
          ticketOrderCountStatVoList.forEach((item) => {
            arr1.push(item.statTime);
            this.orderTimeList = arr1;
            list2.push(item.ticketOrderCount);
            this.echartsDataOrder = list2;
          });
          // 开始折线图
          // this.chartUser();
          // this.chartOrder();
        } else {
          this.$message.error(res.data.info);
        }
      });
    },
    // 获取剩余天数
    getRestOfDay(createTime) {
      let _d_tm = new Date(new Date().valueOf());
      let _d_now = new Date(new Date().valueOf());
      if (createTime) {
        _d_now = new Date(createTime.replace(/-/g, "/"));
      }
      // if(_d_now<_d_tm){
      //   return '已过期'
      // }
      // if(_d_now > _d_tm){
      //   return '续费'
      // }
      let leftTime = ~~((_d_now - _d_tm) / 1000 / 60 / 60 / 24);
      if (leftTime < 90) {
        this.topShow = true;
      }
      return leftTime;
    },
    // 数字的原本小数位数不到两位，那么缺少的就自动补零
    returnFloat(num) {
      num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
      if (num.indexOf(".") !== -1) {
        let [integerPart, decimalPart] = num.split(".");

        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2);
        } else if (decimalPart.length === 1) {
          decimalPart += "0";
        }

        num = `${integerPart}.${decimalPart}`;
      } else {
        num += ".00";
      }

      return num;
    },
  },
};
</script>

<style scoped lang="less">
.times-tab {
  margin-right: 30px;
}
.content {
  width: 100%;

  .top {
    height: 40px;

    .top-text {
      height: 40px;
      display: flex;
      align-items: center;
      margin-left: 16px;

      .text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-left: 8px;

        span {
          color: #ff4f76;
          cursor: pointer;
        }
      }
    }
  }
  .center-asset {
    background: #ffffff;
    border-radius: 8px;
    // height: 176px;
    margin-top: 10px;
    // display: flex;
    align-items: center;
    padding: 20px;
    .center-top-title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 25px;
    }
    .center-top-flex {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 34px;

      .center-top-box {
        display: flex;
        align-items: flex-start;
        height: 85px;
        width: 220px;
        // margin-right: 130px;
        .box {
          margin-left: 12px;

          &-link {
            cursor: pointer;
            color: #3d9efc;
            font-size: 12px;
            line-height: 24px;
          }

          .box-number {
            font-size: 28px;
            font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #333333;
            line-height: 38px;
          }

          .box-text {
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #999999;
            line-height: 20px;
          }
        }

        .button-cz {
          width: 76px;
          height: 36px;
          background: #ff8622;
          border-radius: 2px;
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #ffffff;
          line-height: 36px;
          text-align: center;
          cursor: pointer;
        }

        .button-tx {
          width: 76px;
          height: 36px;
          border-radius: 2px;
          border: 1px solid #ff8622;
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #ff8622;
          line-height: 36px;
          text-align: center;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .center-top {
    background: #ffffff;
    border-radius: 8px;
    height: 176px;
    padding: 20px;
    margin-top: 10px;

    .center-top-title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 25px;
    }

    .center-top-flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 34px;

      .center-top-box {
        display: flex;
        align-items: flex-start;
        height: 90px;
        width: 220px;
        .box {
          margin-left: 12px;

          &-link {
            cursor: pointer;
            color: #3d9efc;
            font-size: 12px;
            line-height: 24px;
          }

          .box-number {
            font-size: 28px;
            font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #333333;
            line-height: 38px;
          }

          .box-text {
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #999999;
            line-height: 20px;
          }
        }

        .button-cz {
          width: 76px;
          height: 36px;
          background: #ff8622;
          border-radius: 2px;
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #ffffff;
          line-height: 36px;
          text-align: center;
          cursor: pointer;
        }

        .button-tx {
          width: 76px;
          height: 36px;
          border-radius: 2px;
          border: 1px solid #ff8622;
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #ff8622;
          line-height: 36px;
          text-align: center;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }

  .center-div {
    height: 196px;
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
    padding: 20px;

    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
    }

    .center-div-flex {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .box {
        width: 48%;
        height: 101px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #f5f5fa;
        display: flex;
        align-items: center;
        padding: 20px;
        justify-content: space-between;
        margin-top: 20px;

        .number {
          font-size: 24px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #333333;
          line-height: 33px;
        }

        .text {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #999999;
          line-height: 20px;
        }
      }
    }
  }
}

.bottom {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .bottom-message {
    width: 49%;
    padding: 23px 20px;
    background: #ffffff;
    border-radius: 8px;

    .bottom-message-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .text {
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 22px;
      }

      .select {
        display: flex;
        align-items: center;

        .select-div {
          border: 1px solid #f0f1f5;
          padding: 7px 16px;
          font-size: 12px;
          font-family: FZLTHJW--GB1-0, FZLTHJW--GB1;
          font-weight: normal;
          color: #666666;
          line-height: 14px;
          cursor: pointer;
        }

        .active {
          border: 1px solid #ff8622 !important;
          color: #ff8622 !important;
        }
      }
    }

    .echarts-box {
      width: 100%;
      height: 364px;
    }
  }
}

/deep/ .el-carousel__item {
  background: #fff6f8;
  border-radius: 4px;
  border: 1px solid #ffcad5;
}

/deep/ .el-carousel__indicators--outside {
  position: absolute;
  right: 20px;
  bottom: 0;
  top: 4px;
  margin: auto;
  left: auto;
}

/deep/ .el-carousel__button {
  width: 8px;
  height: 8px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 100%;
  display: none;
}

/deeep/ .el-carousel__indicator.is-active button {
  background: #ff4f76 !important;
}

.space {
  display: flex;
  align-items: center;

  &-item:first-child {
    width: 50%;
  }

  &-item:last-child {
    width: 50%;

    padding-left: 2%;
  }

  &-item {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }
}
.center-transaction {
  background: #fff;
  border-radius: 8px;
  margin-top: 20px;
  padding: 20px;
  .center-top-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 25px;
      margin-right: 40px;
    }
  }
  .transaction-tab {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    .transaction-tab-item {
      .transaction-tab-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        box-sizing: border-box;
        padding: 10px 0;
        .tab-box-num {
          font-size: 28px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #333333;
          line-height: 38px;
        }
        .tab-box-text {
          display: flex;
          align-items: center;
          .tab-box-text-s {
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #999999;
            line-height: 20px;
          }
          .tipss {
            color: #909399;
          }
        }
      }
      .tab-active {
        border-bottom: 4px solid #ff8622;
        border-radius: 2px;
        color: #ff8622 !important;
      }
    }
  }
  .echarts-new {
    width: 100%;
    height: 364px;
    // background: rgba(255, 255, 255, .8);
  }
}
.active-font {
  color: #ff8622 !important;
}
.tips-icons{
  color: #909399;
}
// /deep/ .el-input__inner {
//   border-color:red;
// }
.active-time{
  border-color:#ff8622;
}

</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/home/index.vue